export type Page = { id: number; html: string };

export const BUTTONS_STYLES = 'w-8 h-7 rounded-lg border border-neutral-200 text-lg cursor-pointer';

export const BUTTONS_STYLES_MODE = (isButtonVisible: boolean): string =>
  isButtonVisible ? '[&>svg]:stroke-primary-500' : '[&>svg]:stroke-neutral-800 dark:[&>svg]:stroke-neutral-200';
